<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>

  <div>
    <div class="card card-ui-no-border bg-color-light mb-3" id="list">
      <div class="card-body">
        <div class="row">
          <div class="col-8">
            <h1 v-if="!specificUser" class="color-registry-dark"></h1>
            <h1 v-else class="color-resource-dark">Registries associated with user {{specificUser['email']}} - id #{{specificUser['id']}}</h1>
          </div>
          <div class="col-4">
            <div v-html="paginateHtml" class="d-flex justify-content-center"></div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-text">
          <!-- filter buttons -->
          <div class="row ml-3 mt-4">
            <a v-if="filter == 'all'" :href="getFilterButtonURL('all')" class="btn btn-registry btn-sm mt-auto mr-3 mb-2">All ({{irrInfo.total}})</a>
            <a v-else :href="getFilterButtonURL('all')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">All ({{irrInfo.total}})</a>
            <a v-if="filter == 'owner'" :href="getFilterButtonURL('owner')" class="btn btn-registry btn-sm mt-auto mr-3 mb-2">Owner ({{irrInfo.numOwner}})</a>
            <a v-else :href="getFilterButtonURL('owner')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Owner ({{irrInfo.numOwner}})</a>
            <a v-if="filter == 'admin'" :href="getFilterButtonURL('admin')" class="btn btn-registry btn-sm mt-auto mr-3 mb-2">Admin ({{irrInfo.numAdmin}})</a>
            <a v-else :href="getFilterButtonURL('admin')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Admin ({{irrInfo.numAdmin}})</a>
            <a v-if="filter == 'pendingrequests'" :href="getFilterButtonURL('pendingrequests')" class="btn btn-registry btn-sm mt-auto mr-3 mb-2">Pending Resource Requests ({{irrInfo.numPendResourcePubReqs}})</a>
            <a v-else :href="getFilterButtonURL('pendingrequests')" class="btn btn-unselected btn-sm mt-auto mr-3 mb-2">Pending Resource Requests ({{irrInfo.numPendResourcePubReqs}})</a>
          </div>
        </div>

        <div class="card border-dark bg-color-light mt-4">
          <table class="table table-sm table-borderless table-hover">
            <thead class="border-bottom-dark">
              <tr>
                <th scope="col" class="larger pl-3">Name</th>
                <th scope="col" class="larger d-none d-md-table-cell"># Resources</th>
                <th scope="col" class="larger d-none d-md-table-cell"># Pending Requests</th>
                <th scope="col" class="larger d-none d-md-table-cell">Role</th>
                <th v-if="route == 'index'" scope="col" class="larger"></th> <!-- Column for actions that can be taken -->
              </tr>
            </thead>
              <tr v-for="i in results.data">
                <th><a :href="createIrrURL(i.irrs.id)">{{i.irrs.name}}</a></th>
                <th v-html="i.irrs.resourcestates_count"></th>
                <th v-html="i.irrs.resourcepublishrequests_count"></th>
                <th v-html="i.role.display_name"></th>
                <th>
                  <div class="dropdown dropleft">
                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="actionsDropdownButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item" v-on:click="$emit('change-active-irr', i.irrs.id)" href="javascript:void(0)">Show on map</a>
                      <a class="dropdown-item" :href="createIrrURL(i.irrs.id)">View</a>
                      <a class="dropdown-item" :href="createIrrEditURL(i.irrs.id)">Edit</a>
                      <a v-if="permissions.currentPermissions.SYS_TRANSFER_IRR || i.irrs.isOwner" class="dropdown-item" :href="createIrrTransferURL(i.irrs.id)">{{ i.irrs.pendingTransfer ? 'Cancel Transfer Ownership Request' : 'Transfer Ownership' }}</a>
                    </div>
                  </div>
                </th>
              </tr>
            <tbody>
            </tbody>
          </table>
        </div>

      </div>

    </div>
  </div>



</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        results: Object,
        resourceFramework: Object,
        paginateHtml: String,
        filter: String,
        irrInfo: Object,
        specificUser: [Object, Array, Boolean],
      },
      data: function() {
        return {}
      },
      methods: {
        createIrrURL: function(id) {
          return '/irr/' + id;
        },
        createIrrEditURL: function(id) {
          return '/irr/' + id + '/edit';
        },
        createIrrTransferURL: function(id) {
          return '/irr/' + id + "/?transfer=1"
        },
        getRoleHtml: function(role) {
          if(role == "Admin") {
            var html = '<span class="color-resource-dark">Admin</span>';
          } else if(role == "Owner") {
            var html = '<span class="color-registry-dark">Owner</span>';
          } else {
            return role;
          }
          return html;
        },
        getFilterButtonURL: function(filter) {
          var url = '/irr';

          if(filter != 'all') {
            url += '/index/' + filter;
          }

          if(this.specificUser) {
            url += '?userid=' + this.specificUser.id;
          }

          return url + '#list';
        },
      },
      created() {
        //
      },
      mounted() {
        //
      }
    }
</script>
